import React from 'react';
import { Search, X } from 'lucide-react';
import { useI18n } from '../../i18n/I18nContext';

/**
 * SearchInput — the one search field (spec §3.9): a `.ds-search` pill (40px; 44px on touch) with a
 * search icon and a clear button that appears once something is typed.
 *
 *   <SearchInput value={q} onChange={setQ} placeholder="Qidirish..." aria-label="O'quvchilarni qidirish" />
 *
 * `onChange` receives the new string (not the event). Props: value, onChange, placeholder,
 * aria-label, className, autoFocus, id, onClear (called after the field is cleared).
 */
function SearchInput({
  value = '',
  onChange,
  placeholder,
  'aria-label': ariaLabel,
  className = '',
  autoFocus = false,
  id,
  onClear,
}) {
  const { t } = useI18n();
  const clear = () => {
    onChange?.('');
    onClear?.();
  };
  return (
    <label className={`ds-search ${className}`.trim()}>
      <Search aria-hidden="true" />
      <input
        id={id}
        type="search"
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        placeholder={placeholder}
        aria-label={ariaLabel || placeholder}
        autoFocus={autoFocus}
        autoComplete="off"
        data-no-style
      />
      {value && (
        <button type="button" className="ds-search-clear" onClick={clear} aria-label={t('ui.clearSearch')}>
          <X aria-hidden="true" />
        </button>
      )}
    </label>
  );
}

export default SearchInput;
